<template>
  <div class="main-head-activity-list" v-loading="loading">
    <img src="../../../../assets/activity/rank_head.png" width="95%"
         style="position: absolute;left: 0;right: 0;margin: auto;top: 0.5rem" alt="">
    <div>
      <div style="position: absolute;top: 4rem;left: 0;right: 0;margin: auto;text-align: center">
        <div class="gift-list-btn-z" @click="clickChange(2)"
             v-bind:style="{'backgroundImage':(currentIndex===2)? 'url('+choose_bnt_z+ ')': 'url('+unchoose_bnt_z+ ')'}">
        </div>
        <div class="gift-list-btn-y" @click="clickChange(1)"
             v-bind:style="{'backgroundImage':(currentIndex===1)? 'url('+choose_bnt_y+ ')': 'url('+unchoose_bnt_y+ ')'}">
        </div>
        <div class="activity-list-background"  >
          <img src="../../../../assets/activity/top1_botton.png"
               style="position: absolute;top: -0.38rem;left: 0;right: 0;margin: auto" width="37%" alt="">
          <!--第一名-->
          <div v-for="(item,index) in activityList"  v-if="index===0">
            <div class="avatar-box-top1">
            </div>
            <div>
              <img v-if="item.userId!==0" style="width:2.1rem;height:2.1rem;position: absolute;left: 0;right:0;top: 0.58rem;margin: auto;z-index: 2;border: #ffd236 0.07rem solid;text-align: center" class="box-img-avatar" :src="item.avatar"/>
              <div v-if="item.userId===0" style="width:2.1rem;height:2.1rem;position: absolute;left: 0;right:0;top: 0.58rem;margin: auto;z-index: 2;border: #ffd236 0.07rem solid;text-align: center" class="box-img-avatar" :src="item.avatar"/>
              <div style="position: absolute;left: 0;right: 0;top:2.9rem;margin: auto;text-align: center">
                <div style="color: rgba(46, 95, 213, 100);font-size: 0.35rem;">{{ item.nickName| ellipsis }}</div>
                <div style="color:rgba(248, 103, 51, 100);font-size: 0.3rem;margin-top: 0.15rem">{{item.score }}</div>
              </div>
            </div>
          </div>
          <!--第二名-->
          <div  v-for="(item,index) in activityList"  v-if="index===1">
            <div class="avatar-box-top2">
            </div>
            <div>
              <img v-if="item.userId!==0" style="width:1.7rem;height:1.7rem;position: absolute;left: 0.65rem;top: 0.98rem;z-index: 2;border: #d3c4ec 0.07rem solid;text-align: center" class="box-img-avatar" :src="item.avatar"/>
              <div v-if="item.userId===0" style="width:1.7rem;height:1.7rem;position: absolute;left: 0.65rem;top: 0.98rem;z-index: 2;border: #d3c4ec 0.07rem solid;text-align: center" class="box-img-avatar" :src="item.avatar"/>
              <div style="position: absolute;left: 0;right:0;top:2.9rem;margin-right: 5.8rem;text-align: center;">
                <div style="color: rgba(46, 95, 213, 100);font-size: 0.35rem;">{{ item.nickName| ellipsis }}</div>
                <div style="color:rgba(248, 103, 51, 100);font-size: 0.3rem;margin-top: 0.15rem">{{item.score }}</div>
              </div>
            </div>
          </div>
          <!--第三名-->
          <div  v-for="(item,index) in activityList"  v-if="index===2">
            <div class="avatar-box-top3 ">
            </div>
            <div>
              <img v-if="item.userId!==0" style="width:1.7rem;height:1.7rem;position: absolute;right: 0.65rem;top: 0.98rem;z-index: 2;border: #d38a60 0.07rem solid;text-align: center" class="box-img-avatar" :src="item.avatar"/>
              <div v-if="item.userId===0" style="width:1.7rem;height:1.7rem;position: absolute;right: 0.65rem;top: 0.98rem;z-index: 2;border: #d38a60 0.07rem solid;text-align: center" class="box-img-avatar" :src="item.avatar"/>
              <div style="position: absolute;right:0;left:0;top:2.9rem;margin-left: 5.8rem;text-align: center">
                <div style="color: rgba(46, 95, 213, 100);font-size: 0.35rem;">{{ item.nickName| ellipsis }}</div>
                <div style="color:rgba(248, 103, 51, 100);font-size: 0.3rem;margin-top: 0.15rem">{{item.score}}</div>
              </div>
            </div>
          </div>
          <div  v-for="(item,index) in activityList"  class="list-activity-row-css" v-if="index+1>3" :style="{'top':[4+2*(index-3)]+'rem','border-radius':(index+1===10 )? '0 0 13px 13px':0,'background':((index+1)%2===0)? '-webkit-linear-gradient(right,rgba(255, 255, 255, 1), rgba(255, 231, 180, 1)) no-repeat':'rgba(255, 249, 238, 1)'}"
                style="position: absolute;z-index: 2;height: 2rem;background: -webkit-linear-gradient(right,rgba(255, 255, 255, 1), rgba(255, 231, 180, 1)) no-repeat;width: 100%;">
              <div class="circle-progress">{{index+1 }}</div>
              <img style="width:1.2rem;height: 1.2rem;position: relative;left: 0.3rem;border: #fc824c 0.05rem solid;" class="activity-box-img-avatar" :src="item.avatar">
              <span style="color: rgba(46, 95, 213, 100);font-size: 0.35rem;font-weight: bold;width: 3rem">{{ item.nickName| ellipsis2 }}</span>
              <div>
                <div
                  style="color:rgba(46, 95, 213, 100);font-size: 0.3rem;text-align: right;width: 3rem;position: relative;right: 0.2rem;">
                  积分值
                </div>
                <div style="color:rgba(248, 103, 51, 100);font-size: 0.4rem;text-align: right;position: relative;right: 0.2rem;">
                  {{ item.score }}
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>



<!--    我的排名-->
        <div class="my-list-activity-background">
          <div class="list-valentine-row-css" style="padding: 0.25rem">
            <el-image :src="myDataPojo.avatar" class="box-img-avatar"
                      style="width:1.3rem;height:1.3rem;margin-left: 0.4rem;">
            </el-image>
            <span
              style="font-size: 0.35rem;margin-left: 0.2rem;color:rgba(255, 255, 255, 100);width: 4.3rem">
                          <div style="font-size: 0.35rem;">
                           我的排名：<a v-if="myDataPojo.rank<10">{{ myDataPojo.rank + 1 }}</a><a
                            v-if="myDataPojo.rank>=10">暂未上榜</a>
                          </div>
                           <div style="margin-top: -2rem;font-size: 0.45rem;font-weight: 500">
                            {{ myDataPojo.nickName }}
                          </div>
                        </span>
            <span style="font-size: 0.35rem;float: right;width: 4.3rem;text-align: right;margin-right: 0.2rem;color: rgba(255, 255, 255, 100)">
                          <div style="font-size: 0.4rem">
                           {{ myDataPojo.score }}
                          </div>
                           <div style="margin-top: -2rem;font-size: 0.3rem;">
                           积分值
                          </div>
                        </span>
          </div>
        </div>
  </div>
</template>

<script>
import {activityBean} from "../../../../api/activity/activity";

export default {
  name: "LaborList",
  filters: {
    ellipsis(value) {
      if (!value) return ''
      if (value.length > 4) {
        return value.slice(0, 4) + '...'
      }
      return value
    },

    ellipsis2(value) {
      if (!value) return ''
      if (value.length > 5) {
        return value.slice(0, 5) + '...'
      }
      return value
    }
  },
  data() {
    return {
      queryParams: {
        sex: 2,
        type: 7,
        token: this.$route.params.token
      },
      nickName: "用户名称用户名称",
      isShow: false,
      // 遮罩层
      loading: true,
      //当前选项卡的索引
      currentIndex: 2,
      choose_bnt_z: require("../../../../assets/activity/choose_bnt_z.png"),
      choose_bnt_y: require("../../../../assets/activity/choose_bnt_y.png"),
      unchoose_bnt_z: require("../../../../assets/activity/unchoose_bnt_z.png"),
      unchoose_bnt_y: require("../../../../assets/activity/unchoose_bnt_y.png"),
      myDataPojo: {},

      //榜单列表
      activityList: [],

    }
  },
  mounted: function () {
    this.loading = false
    this.getData()
  },
  methods: {
    clickChange: function (index) {
      if (this.currentIndex !== index) {
        this.currentIndex = index;
        this.queryParams.sex = this.currentIndex
        this.getData()
      }
    },

    //列表
    getData() {
      this.loading = true
      activityBean(this.queryParams).then(response => {
        if (response.data) {
          let data = response.data;
          this.activityList = data.activityList
          this.myDataPojo = data.myDataPojo
        }
      })
      this.loading = false
    },

  }
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/pomelo/app/labor/list.vue